import { render } from "./adfs-postflight-component.vue?vue&type=template&id=5e4617b8"
import script from "./adfs-postflight-component.vue?vue&type=script&lang=js"
export * from "./adfs-postflight-component.vue?vue&type=script&lang=js"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__